import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue';
import { Message } from '@daocloud-proto/ghippo/v1alpha1/message.pb';
import userStorage from '@/utils/userStorage';


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemMessage',
  setup(__props) {

const isShow = ref(false);

const message = ref('');

const fetchSysMessage = async () => {
  try {
    ({ show: isShow.value = false, message: message.value = '' } = await Message.GetSystemMessage({}));
  } catch (e) {
    console.error(e);
  }
};

if (userStorage.value.showSysMessage) {
  fetchSysMessage();
}

const handleClosed = () => {
  userStorage.value.showSysMessage = false;
};

const realShow = computed(() => userStorage.value.showSysMessage && isShow.value);


return (_ctx: any,_cache: any) => {
  const _component_dao_message = _resolveComponent("dao-message")!

  return (_unref(realShow))
    ? (_openBlock(), _createBlock(_component_dao_message, {
        key: 0,
        class: "ghippo-system-message",
        type: "warning",
        content: message.value,
        onClosed: handleClosed
      }, null, 8, ["content"]))
    : _createCommentVNode("", true)
}
}

})